import { default as Body } from './Body';
import { default as Head } from './Head';

export const Text = { Body, Head };
